<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">
      拟offer <peixun type="11" style="display:inline-block;margin-left:5px;position:relative;top:3px;"></peixun>
    </div>
    <el-form ref="form" :model="form" label-width="120px" size="mini">
      <el-form-item label="候选人:"> {{ form['候选人'] }} </el-form-item>
      <el-form-item label="推荐顾问:"> {{ form['顾问'] }} </el-form-item>
      <el-form-item label="职位">
        <el-input v-model="form['职位']" placeholder="客户给到的职位"></el-input>
      </el-form-item>
      <el-form-item label="专业职级">
        <el-input v-model="form['专业职级']" placeholder="客户给到的专业职级"></el-input>
      </el-form-item>
      <el-form-item label="固定年薪">
        <el-input
          v-model="form['固定年薪']"
          placeholder="填写全年的固定薪酬，如果不确认可以填写一个大概的数字"
          @change="changeYongjin"
          @blur="checkAnnualSalary(false)"
        >
          <template slot="append">
            万
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="offer签订日期">
        <el-date-picker v-model="form['offer签订日期']" type="date" placeholder="选择日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="预计到岗时间">
        <el-date-picker v-model="form['预计到岗时间']" type="date" placeholder="选择日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form['备注']" placeholder="特殊说明可填写备注"></el-input>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item label="合同比例">
        <el-col :span="12">
          <el-select v-model="biliType" @change="changeYongjin">
            <el-option label="选择比例" value="选择比例"></el-option>
            <el-option label="固定收费" value="固定收费"></el-option>
            <el-option label="最低收费" value="最低收费"></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" v-if="biliType == '选择比例'">
          <el-input
            v-model="form['合同比例']"
            placeholder="点击查看合同附件可查看合同"
            @change="changeYongjin"
          ></el-input>
        </el-col>
        <el-col :span="2" v-if="biliType == '选择比例'"> % </el-col>
      </el-form-item>
      <el-form-item label="佣金额">
        <el-input
          v-model="form['佣金额']"
          :disabled="biliType == '选择比例'"
          :placeholder="biliType == '选择比例' ? '请填写固定年薪和合同比例' : '请输入数字，用于开票和业绩计算'"
        >
          <template slot="append">
            万
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="rpg-dialog-item rpg-pdl-130">
      <HetongFijian ref="HetongFijian" :companyName="project.客户公司"></HetongFijian>
    </div>
    <div class="rpg-dialog-item rpg-text-center">
      <el-button size="mini" type="primary" @click="handleConfirm">发起offer</el-button>
    </div>
    <div class="rpg-dialog-item rpg-text-center">
      <span class="rpg-tip-red">发起offer会通知相应的顾问，最终双方确认</span>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
      :modal="true"
      :center="true"
      width="430px"
      title="确认年薪"
    >
      <p class="mb10">哇哦，您确定这一单的固定年薪已经<b class="ml10 mr10" style="color:#F56C6C">上亿</b>了吗，这里的单位是<b class="ml10 mr10" style="color:#F56C6C">万</b>哦，如果确定的话，恭喜您成了一个超级大单哦!</p>
      <p class="mb10" style="text-align:center">(ง •̀_•́)ง</p>
      <div class="rpg-dialog-item rpg-text-center">
        <el-button size="mini" type="primary" @click="closeDialog">
          {{dialogCloseTime>0?`${dialogCloseTime}s之后即可关闭`:'关闭'}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import HetongFijian from './hetong-fujian'
import { getYongJin } from '../constant/common-methods'
export default {
  components: { HetongFijian },
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      rid: '',
      pid: '',
      form: {},
      biliType: '选择比例',
      dialogVisible: false,
      dialogCloseTime: 0,
      beforeConfirmCheck: false,
    }
  },
  async mounted() {
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    const res = await app.service('radish').findRecommend({ rid: this.rid, pid: this.pid })
    if (res.status == 'success') {
      if (res.data.length > 0) {
        this.form = {
          isMaybe: true,
          顾问: res.data[0].顾问,
          候选人: this.radish['姓名'],
          rid: this.rid,
          pid: this.pid,
        }
        this.biliType = '选择比例'
      } else {
        this.$message.error('未找到对应推荐数据')
      }
    }
    // console.log(JSON.stringify(this.form))
  },
  methods: {
    checkAnnualSalary(confirmCheck){
      const num = parseInt(this.form.固定年薪) || 0
      if(num>=10000){
        this.dialogCloseTime = 5
        this.dialogVisible = true
        this.setTimeOut(this.dialogCloseTime)
      }
      if(confirmCheck) {
        this.beforeConfirmCheck = true
        if(num<10000) this.handleConfirm()
      }
    },
    setTimeOut(time){
      if(time){
        setTimeout(()=>{
          this.dialogCloseTime = time - 1
          this.setTimeOut(this.dialogCloseTime)
        }, 1000 )
      }
    },
    closeDialog(){
      if(this.dialogCloseTime<=0) this.dialogVisible = false
    },
    async handleConfirm() {
      let floatNum = /^\d+(\.\d+)?$/
      const form = Object.assign({}, this.form)
      if (form.固定年薪 && !floatNum.test(form.固定年薪)) return this.$message('固定年薪只能填写数字')
      if(!this.beforeConfirmCheck) return this.checkAnnualSalary(true)
      else this.beforeConfirmCheck = true
      if (form.合同比例 && !floatNum.test(form.合同比例)) return this.$message('合同比例只能填写数字')
      if (form.试用期 && !floatNum.test(form.试用期)) return this.$message('试用期只能填写数字')
      if (form.佣金额 && !floatNum.test(form.佣金额)) return this.$message('佣金额只能填写数字')
      if (this.biliType == '固定收费' || this.biliType == '最低收费') form.合同比例 = this.biliType
      const res = await app.service('radish').addOfferMaybe(form)
      if (res.status == 'success') {
        this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    changeYongjin() {
      if (this.biliType == '选择比例') {
        const money = parseFloat(this.form.固定年薪)
        const per = parseFloat(this.form.合同比例)
        if (!isNaN(money) && !isNaN(per)) {
          this.form = Object.assign({}, this.form, { 佣金额: getYongJin(money, per) })
        }
      }
    }
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
